export const titleBase = "Sebastian Sierra |";
export const navItems = [
  {
    url: "/",
    name: "Inicio",
  },
  {
    url: "/acerca-de-mi",
    name: "Acerca de mí",
  },
];
